import React, { Component } from "react";

import * as apiUtil from "../../../util/apiUtil";

import reward from '../component/reward.png';
import '../reward.css';
import {aesDecrypt} from "../../../util/aes256";

class RewardCompleteContainer extends Component {
    constructor(props) {
        super(props);

        this.saveKakaoUserInfo = this.saveKakaoUserInfo.bind(this);
        this.ajaxRewardProcess = this.ajaxRewardProcess.bind(this);

        this.state = {
            decryptedState: {},
        };
    }

    componentDidMount() {
        const { state } = this.props;

        const stateStr = state.replace(/ /g, '+');
        const decryptedState = JSON.parse(aesDecrypt(stateStr));

        this.setState({ decryptedState: decryptedState })

        if (decryptedState && decryptedState.type === 'KAKAO') {
            this.saveKakaoUserInfo();
        } else if (decryptedState.type === 'NAVER') {
            this.saveNaverUserInfo();
        }
    }

    saveKakaoUserInfo() {
        const { code, state } = this.props;

        const stateStr = state.replace(/ /g, '+');
        apiUtil.asyncRequest({
            url: `/api/reward/kakao/user?code=${code}&state=${encodeURIComponent(stateStr)}`,
            method: apiUtil.requestMethod.POST,
            success: (res) => {

            }
        })
    }

    // 네이버 사용자 정보 저장
    saveNaverUserInfo() {
        const { code, state } = this.props;

        const stateStr = state.replace(/ /g, '+');
        apiUtil.asyncRequest({
            url: `/api/reward/naver/user?code=${code}&state=${encodeURIComponent(stateStr)}`,
            method: apiUtil.requestMethod.POST,
            success: (res) => {

            }
        })
    }

    ajaxRewardProcess() {
        const { decryptedState } = this.state;
        apiUtil.asyncRequest({
            url: "/api/reward/decrypt",
            method: apiUtil.requestMethod.POST,
            data: {
                data: decryptedState.data,
            },
            success: (result) => {
                window.location.href = result.rewardUrl;
            }
        })
    }

    render() {
        const { ajaxRewardProcess } = this;

        return (
            <div className="reward-outer">
                <img src={reward} alt="register.png" className="register-image"/>
                <button
                    onClick={ajaxRewardProcess}
                    className="btn-naver-reward btn btn-md w-100 lh-base"
                >
                    <span>네이버 페이 적립받기</span>
                </button>
            </div>
        )
    }
}

export default RewardCompleteContainer;
